import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import OtaDeviceList from '@blade-sxp/ota-management/components/ota-device-list.vue';
import FullScreen from '@blade/common/components/full-screen.vue';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class extends Vue {
    srcMsg = require('@blade/common/assets/svgs/enlarge.svg');
    srcMsg2 = require('@blade/common/assets/svgs/narrow.svg');
    onFullScreenFlag = false;
    groupId = 0;
    keywords = '';
    code1 = '030102';
    code2 = '030106';
    handleClear() {
        this.keywords = '';
    }
    handleCreate() {
        this.$router.push('/setting/otaManagement/otaCreate');
    }
    handleSearch() {
        this.$refs.otaList.refresh();
    }
    handleRefresh() {
        this.$refs.otaList.refresh();
    }
};
default_1 = __decorate([
    Component({
        name: 'Log',
        components: {
            OtaDeviceList,
            FullScreen,
            AuthItem,
        },
        i18n: {
            messages: {
                'en-us': {
                    search: 'Search',
                    taskList: 'The Task List',
                    createTask: 'Create Task',
                    searchPlaceHolder: 'Package name/Version/Type',
                },
                zh: {
                    search: '搜索',
                    taskList: '任务列表',
                    createTask: '新建',
                    searchPlaceHolder: '更新包名称/更新包版本/更新包类型',
                },
            },
        },
    })
], default_1);
export default default_1;
